import { useEffect } from "react";
import axios, { CancelTokenSource } from "axios";
import { RequestMiddleware } from "./RequestUtil";

type ISourceUtilActions = {
  cancel: () => void;
};

interface ICancelTokenMiddleware extends RequestMiddleware<ISourceUtilActions> {
  actions: ISourceUtilActions;
}

export function CancelTokenMidleware(): ICancelTokenMiddleware {
  let source: CancelTokenSource;

  const sourceUtil = {
    get token() {
      if (source) {
        source.cancel();
      }
      source = axios.CancelToken.source();
      return source.token;
    },
    cancel() {
      if (source) source.cancel();
    }
  };

  return {
    get config() {
      return {
        cancelToken: sourceUtil.token
      };
    },
    actions: {
      cancel: sourceUtil.cancel
    },
    hooks: [
      function useCancelRequestOnUnmount() {
        useEffect(
          () => () => {
            sourceUtil.cancel();
          },
          []
        );
      }
    ]
  };
}
